import React, { useState, useEffect, useRef } from 'react';
import style from './RezRateTable.style';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronLeft, faChevronRight, faChevronUp, faMinus } from '@fortawesome/free-solid-svg-icons';
import { clone, isFunction } from 'lodash';
import { Button, ButtonGroup, Input, Label } from 'reactstrap';

const RezRateTable = (props) => {
  const {
    columns, // Array of objects with keys: dataKey, label, width, cellFormatter, headerFormatter
    data, // Array of objects
    noDataMessage, // what to display when no data
    onRowClick, // function to call when a row is clicked
    tableBodyHeight,
    tableType = '', //striped, noVerticalLines, noHorizontalLines
    rowStyle = () => ({}), // Style for each row in the table
    isPaginated = false,
    maxItemsPerPage = 100,
  } = props;

  // State variables
  const [tableData, setTableData] = useState([]);
  const [tableColumns, setTableColumns] = useState([]);
  const [tableColumnsToDisplay, setTableColumnsToDisplay] = useState([]);
  const [tableDataToDisplay, setTableDataToDisplay] = useState([]); // filtered/sorted/processed version of tableData.
  const [cellBorderStyle, setCellBorderStyle] = useState({});
  const [basicRowStyle, setBasicRowStyle] = useState({});
  const [sortDataKey, setSortDataKey] = useState(null);
  const [sortDirection, setSortDirection] = useState(null); // asc or desc

  const [itemsPerPage, setItemsPerPage] = useState(100);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [pageNumbers, setPageNumbers] = useState([]);

  const [headerSortDataKeyIndex, setHeaderSortDataKeyIndex] = useState({});

  const [startIndex, setStartIndex] = useState(0);
  const [endIndex, setEndIndex] = useState(0);
  const tableRef = useRef(null);

  const [tableToDisplay, setTableToDisplay] = useState(null);
  const [showHidden, setShowHidden] = useState(false);

  const rowHeight = 70;
  const visibleRowCount = Math.ceil(tableBodyHeight / rowHeight);

  const handleScroll = () => {
    // Assuming each row has a fixed height of 30px
    const scrollTop = tableRef.current.scrollTop;
    const totalRows = tableDataToDisplay.length;
    const newStartIndex = Math.floor(scrollTop / rowHeight);
    const newEndIndex = newStartIndex + visibleRowCount;

    setStartIndex(newStartIndex);
    setEndIndex(Math.min(newEndIndex, totalRows));
  };

  // Effects
  useEffect(() => {
    // Fetch data or perform any side effects here
  }, []);

  useEffect(() => {
    if (maxItemsPerPage) {
      setItemsPerPage(maxItemsPerPage);
    }
  }, [maxItemsPerPage]);

  useEffect(() => {
    setTableColumns(columns);
    setTableColumnsToDisplay(columns);
    processHeaderSortDataKeyIndex(columns);

    // }, [JSON.stringify(columns  ? columns : [])]);
  }, [columns]);

  useEffect(() => {
    setTableData(data);
    processPaginationData(data);
    setTableDataToDisplay(sortTableData({ dataToSort: data, sortDirection, sortDataKey, currentPage }));
    // }, [JSON.stringify(data ? data : [])]);
  }, [data]);

  useEffect(() => {
    updateCellBordalStyle(tableType);
  }, [tableType]);

  useEffect(() => {
    // renderTable2();
  }, [tableColumnsToDisplay, tableDataToDisplay, tableType]);

  const processHeaderSortDataKeyIndex = (data) => {
    const { headers = [] } = data;
    const newHeaderSortDataKeyIndex = {};

    headers.forEach((header, index) => {
      const { dataKey, onSort } = header;
      if (onSort) {
        newHeaderSortDataKeyIndex[dataKey] = onSort;
      }
    });

    setHeaderSortDataKeyIndex(newHeaderSortDataKeyIndex);
  };

  const sortTableData = (data) => {
    const { dataToSort = [], sortDirection, sortDataKey, currentPage } = data;
    const sortFunctionToUse = headerSortDataKeyIndex[sortDataKey];
    let sortedData = dataToSort || [];

    if (sortFunctionToUse) {
      sortedData = sortFunctionToUse(dataToSort, sortDirection);

      // setTableDataToDisplay(sortedData);
    } else if (sortDataKey) {
      sortedData = (dataToSort && dataToSort.length > 0 ? [...dataToSort] : []).sort((a, b) => {
        const aValue = a[sortDataKey];
        const bValue = b[sortDataKey];

        if (aValue < bValue) {
          return sortDirection === 'asc' ? -1 : 1;
        }
        if (aValue > bValue) {
          return sortDirection === 'asc' ? 1 : -1;
        }
        return 0;
      });

      // setTableDataToDisplay(sortedData);
    } else {
    }

    if (isPaginated) {
      const startIndex = (currentPage - 1) * itemsPerPage;
      const endIndex = startIndex + itemsPerPage;
      sortedData = sortedData.slice(startIndex, endIndex);
    }

    return sortedData;
  };

  const processHeaderRow2 = (columnData) => {
    const headerColumns = [];
    const disabledHeaderColumns = [];

    columnData.forEach((header, i) => {
      const { dataKey, label, headerFormatter, minWidth, doSort, onSort, headerEvents } = header;

      let {
        width,
        headerAttrs = {},
        headerStyle = () => {
          return {};
        },
      } = header;

      headerStyle = headerStyle
        ? headerStyle
        : () => {
            return {};
          };
      headerAttrs = headerAttrs ? headerAttrs : {};

      headerStyle = isFunction(headerStyle) ? headerStyle(header, i) : headerStyle;
      const { onClick, onMouseEnter, onMouseLeave } = headerEvents || {};

      const headerId = `header-${dataKey}-${label}-${currentPage}`;
      if (doSort) {
        width = width - 15;
      }
      if (headerFormatter) {
        headerColumns.push(
          <th
            key={headerId}
            id={headerId}
            style={{ ...cellBorderStyle, borderTop: '2px solid #cccaca', width, minWidth, ...headerStyle }}
            {...headerAttrs}
            onClick={(e) => {
              if (onClick) {
                onClick({ e, column: header, columnIndex: i });
              }
            }}
            onMouseEnter={(e) => {
              if (onMouseEnter) {
                onMouseEnter({ e, column: header, columnIndex: i });
              }
            }}
            onMouseLeave={(e) => {
              if (onMouseLeave) {
                onMouseLeave({ e, column: header, columnIndex: i });
              }
            }}
          >
            <div
              dataProp={`width_${width}`}
              style={{
                ...style.simpleRow,
                padding: 5,
                fontWeight: 'bold',
                width: width && width.toString().indexOf('%') >= 0 ? null : width,
              }}
            >
              {headerFormatter(header, i)}
              {doSort ? (
                <div
                  style={{ cursor: 'pointer', width: 30 }}
                  onClick={() => {
                    let newSortDirection = null;

                    if (sortDataKey === dataKey) {
                      newSortDirection = sortDirection === 'asc' ? 'desc' : 'asc';
                    } else {
                      newSortDirection = 'asc';
                      setSortDataKey(dataKey);
                    }

                    setSortDirection(newSortDirection);
                    if (onSort) {
                      onSort({
                        sortDataKey: dataKey,
                        sortDirection: newSortDirection,
                        dataToSort: clone(tableData),
                        callback: (newData, order) => {
                          setSortDirection(order);
                          setSortDataKey(dataKey);

                          setTableDataToDisplay((prev) =>
                            sortTableData({
                              dataToSort: newData,
                              sortDirection: order,
                              sortDataKey: null,
                              currentPage,
                            }),
                          );
                        },
                      });
                      // setSortDataKey(dataKey);
                      // setSortDirection(newSortDirection);
                    } else {
                      setSortDataKey(dataKey);
                      setSortDirection(newSortDirection);
                      setTableDataToDisplay((prev) =>
                        sortTableData({
                          dataToSort: prev,
                          sortDirection: newSortDirection,
                          sortDataKey: dataKey,
                          currentPage,
                        }),
                      );
                    }
                  }}
                >
                  {sortDataKey === dataKey ? (
                    sortDirection === 'asc' ? (
                      <FontAwesomeIcon icon={faChevronUp} />
                    ) : (
                      <FontAwesomeIcon icon={faChevronDown} />
                    )
                  ) : (
                    <FontAwesomeIcon icon={faMinus} />
                  )}
                </div>
              ) : null}
            </div>
          </th>,
        );
        disabledHeaderColumns.push(
          <th
            key={`${headerId}-disabled`}
            id={`${headerId}-disabled`}
            style={{ ...cellBorderStyle, width, minWidth, ...headerStyle }}
            {...headerAttrs}
            disabled={true}
          >
            <div
              dataProp={`width_${width}`}
              style={{ ...style.simpleRow, padding: 5, fontWeight: 'bold', width }}
              disabled={true}
            >
              {headerFormatter({ ...header, hiddenParent: true }, i)}
              {doSort ? (
                <div style={{ cursor: 'pointer', width: 30 }}>
                  {sortDataKey === dataKey ? (
                    sortDirection === 'asc' ? (
                      <FontAwesomeIcon icon={faChevronUp} />
                    ) : (
                      <FontAwesomeIcon icon={faChevronDown} />
                    )
                  ) : (
                    <FontAwesomeIcon icon={faMinus} />
                  )}
                </div>
              ) : null}
            </div>
          </th>,
        );
        return;
      }

      headerColumns.push(
        <th
          key={headerId}
          id={headerId}
          style={{ ...cellBorderStyle, borderTop: '2px solid #cccaca', width, minWidth, ...headerStyle }}
          {...headerAttrs}
          onClick={(e) => {
            if (onClick) {
              onClick({ e, column: header, columnIndex: i });
            }
          }}
          onMouseEnter={(e) => {
            if (onMouseEnter) {
              onMouseEnter({ e, column: header, columnIndex: i });
            }
          }}
          onMouseLeave={(e) => {
            if (onMouseLeave) {
              onMouseLeave({ e, column: header, columnIndex: i });
            }
          }}
        >
          <div
            dataProp={`width_${width}`}
            style={{
              ...style.simpleRow,
              padding: 5,
              fontWeight: 'bold',
              width: width && width.toString().indexOf('%') >= 0 ? null : width,
            }}
          >
            <div style={{ width: '100%', textAlign: 'center' }}>{label}</div>
            {doSort ? (
              <div
                style={{ cursor: 'pointer', width: 30 }}
                onClick={() => {
                  let newSortDirection = null;

                  if (sortDataKey === dataKey) {
                    newSortDirection = sortDirection === 'asc' ? 'desc' : 'asc';
                  } else {
                    newSortDirection = 'asc';
                    setSortDataKey(dataKey);
                  }

                  setSortDirection(newSortDirection);
                  if (onSort) {
                    onSort({
                      sortDataKey: dataKey,
                      sortDirection: newSortDirection,
                      dataToSort: clone(tableData),
                      callback: (newData, order) => {
                        setSortDirection(order);
                        setSortDataKey(dataKey);

                        setTableDataToDisplay((prev) =>
                          sortTableData({
                            dataToSort: newData,
                            sortDirection: newSortDirection,
                            sortDataKey: null,
                            currentPage,
                          }),
                        );
                      },
                    });
                  } else {
                    let newSortDirection = null;

                    if (sortDataKey === dataKey) {
                      newSortDirection = sortDirection === 'asc' ? 'desc' : 'asc';
                    } else {
                      newSortDirection = 'asc';
                      setSortDataKey(dataKey);
                    }

                    setSortDataKey(dataKey);
                    setSortDirection(newSortDirection);
                    setTableDataToDisplay((prev) =>
                      sortTableData({
                        dataToSort: prev,
                        sortDirection: newSortDirection,
                        sortDataKey: dataKey,
                        currentPage,
                      }),
                    );
                  }
                }}
              >
                {sortDataKey === dataKey ? (
                  sortDirection === 'asc' ? (
                    <FontAwesomeIcon icon={faChevronUp} />
                  ) : (
                    <FontAwesomeIcon icon={faChevronDown} />
                  )
                ) : (
                  <FontAwesomeIcon icon={faMinus} />
                )}
              </div>
            ) : null}
          </div>
        </th>,
      );
      disabledHeaderColumns.push(
        <th
          key={`${headerId}_disabled`}
          id={`${headerId}_disabled`}
          style={{ ...cellBorderStyle, width, minWidth, ...headerStyle }}
          {...headerAttrs}
        >
          <div style={{ ...style.simpleRow, padding: 5, fontWeight: 'bold', width }} disabled={true}>
            <div style={{ width: '100%', textAlign: 'center' }}>{label}</div>
            {doSort ? (
              <div style={{ cursor: 'pointer', width: 30 }}>
                {sortDataKey === dataKey ? (
                  sortDirection === 'asc' ? (
                    <FontAwesomeIcon icon={faChevronUp} />
                  ) : (
                    <FontAwesomeIcon icon={faChevronDown} />
                  )
                ) : (
                  <FontAwesomeIcon icon={faMinus} />
                )}
              </div>
            ) : null}
          </div>
        </th>,
      );
    });

    return {
      headerColumns: <tr id={`headers_${currentPage}`}>{headerColumns}</tr>,
      disabledHeaderColumns: <tr id={`headersDisabled_${currentPage}`}>{disabledHeaderColumns}</tr>,
    };
  };

  const updateCellBordalStyle = (tableType) => {
    const newBorderStyle = {};
    newBorderStyle.borderRight = '1px solid #cccaca';
    newBorderStyle.borderBottom = '1px solid #cccaca';

    if (tableType.indexOf('noVerticalLines') > -1) {
      newBorderStyle.borderRight = 'none';
    }

    if (tableType.indexOf('noHorizontalLines') > -1) {
      newBorderStyle.borderBottom = 'none';
    }

    setCellBorderStyle(newBorderStyle);
  };

  // const renderTable = () => {
  //   const rows = [];
  //   const headerRow = processHeaderRow(tableColumnsToDisplay);

  //   tableDataToDisplay.forEach((dataRow, index) => {
  //     const newRow = [];

  //     tableColumnsToDisplay.forEach((header) => {
  //       const { dataKey, width, cellFormatter, formatter, headerFormatter, minWidth } = header;
  //       const cellFormatterActual = cellFormatter || formatter;

  //       if (cellFormatterActual) {
  //         newRow.push(
  //           <div style={{ ...style.simpleColumn, padding: 5, width, textOverflow: 'ellipsis' }}>
  //             {cellFormatterActual(dataRow[dataKey], { ...dataRow, index, column: header })}
  //           </div>,
  //         );
  //       } else {
  //         newRow.push(
  //           <div
  //             style={{
  //               ...style.simpleColumn,
  //               padding: 5,
  //               width,
  //               justifyContent: 'center',
  //             }}
  //           >
  //             <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', width, minWidth, textAlign: 'center' }}>
  //               {dataRow[dataKey] || ''}
  //             </div>
  //           </div>,
  //         );
  //       }
  //     });

  //     rows.push(
  //       <div
  //         style={{
  //           ...style.simpleRow,
  //           borderBottom: '1px solid #cccaca',
  //           backgroundColor: index % 2 == 0 ? 'white' : '#e3e1e1',
  //           cursor: onRowClick ? 'pointer' : 'default',
  //           ...rowStyle(dataRow),
  //         }}
  //         onClick={() => {
  //           if (onRowClick) {
  //             onRowClick(dataRow);
  //           }
  //         }}
  //       >
  //         {newRow}
  //       </div>,
  //     );
  //   });

  //   return (
  //     <div
  //       className="rez-rate-table"
  //       style={{
  //         ...style.simpleRow,
  //         justifyContent: 'flex-start',
  //         alignItems: 'flex-start',
  //         overflowX: 'auto',
  //         width: '100%',
  //       }}
  //     >
  //       <div
  //         style={{
  //           ...style.simpleColumn,
  //           width: '100%',
  //           justifyContent: 'flex-start',
  //           alignItems: 'flex-start',
  //         }}
  //       >
  //         {headerRow}
  //         <div
  //           style={{
  //             ...style.simpleRow,
  //             overflowY: 'auto',
  //             height: tableBodyHeight,
  //             alignItems: 'flex-start',
  //             width: !rows || rows.length <= 0 ? '100%' : null,
  //           }}
  //         >s
  //           <div style={{ ...style.simpleColumn }}>
  //             {rows.map((row, i) => {
  //               return row;
  //             })}
  //             {!rows || rows.length <= 0 ? (
  //               <div
  //                 style={{
  //                   ...style.simpleRow,
  //                   padding: 5,
  //                   width: '100%',
  //                   justifyContent: 'center',
  //                   alignItems: 'center',
  //                 }}
  //               >
  //                 {noDataMessage || ''}
  //               </div>
  //             ) : null}
  //           </div>
  //         </div>
  //       </div>
  //     </div>
  //   );
  // };

  const processPaginationData = (data) => {
    const maxVisibleNumbers = 7;
    const newPageNumbers = [];

    const totalItems = data.length;
    const newTotalPages = Math.ceil(totalItems / itemsPerPage);
    const startPage = Math.max(1, currentPage - Math.floor(maxVisibleNumbers / 2));
    const endPage = Math.min(newTotalPages, startPage + maxVisibleNumbers - 1);
    let visiblePageCounter = 0;
    let pageGroupIndex = 0;

    for (let i = startPage; i <= newTotalPages; i++) {
      if (!newPageNumbers[pageGroupIndex]) {
        newPageNumbers[pageGroupIndex] = [];
      }
      newPageNumbers[pageGroupIndex].push(i);
      if (newPageNumbers[pageGroupIndex].length >= maxVisibleNumbers) {
        pageGroupIndex++;
      }
    }
    setTotalPages(newTotalPages);
    setPageNumbers(newPageNumbers);
  };

  const renderPagination = (data) => {
    const { currentPage, pageNumbers } = data || {};
    const pagesToDisplay = pageNumbers.find((pageGroup) => pageGroup.includes(currentPage)) || [];

    return (
      <div
        style={{
          ...style.simpleRow,
          justifyContent: 'center',
          alignItems: 'center',
          padding: 5,
        }}
      >
        <ButtonGroup>
          <Button
            outline
            disabled={currentPage == 1}
            onClick={() => {
              setCurrentPage(1);
              setTableDataToDisplay((prev) =>
                sortTableData({ dataToSort: tableData, sortDirection, sortDataKey, currentPage: 1 }),
              );
            }}
          >
            First{' '}
          </Button>
          <Button
            outline
            disabled={currentPage == 1}
            onClick={() => {
              const newPage = currentPage > 1 ? currentPage - 1 : 1;

              setCurrentPage(newPage);
              setTableDataToDisplay((prev) =>
                sortTableData({ dataToSort: tableData, sortDirection, sortDataKey, currentPage: newPage }),
              );
            }}
          >
            <FontAwesomeIcon icon={faChevronLeft} />
          </Button>
          {pagesToDisplay.map((pageNumber, index) => {
            const isCurrentPage = pageNumber == currentPage;
            return (
              <Button
                outline
                color={isCurrentPage ? 'primary' : 'secondary'}
                onClick={() => {
                  setCurrentPage(pageNumber);
                  setTableDataToDisplay((prev) =>
                    sortTableData({ dataToSort: tableData, sortDirection, sortDataKey, currentPage: pageNumber }),
                  );
                }}
                style={{ fontWeight: isCurrentPage ? 'bold' : null }}
              >
                {pageNumber}
              </Button>
            );
          })}
          <Button
            outline
            disabled={currentPage == totalPages}
            onClick={() => {
              const newPage = currentPage < totalPages - 1 ? currentPage + 1 : totalPages;

              setCurrentPage(newPage);
              setTableDataToDisplay((prev) =>
                sortTableData({ dataToSort: tableData, sortDirection, sortDataKey, currentPage: newPage }),
              );
            }}
          >
            <FontAwesomeIcon icon={faChevronRight} />
          </Button>
          <Button
            outline
            disabled={currentPage == totalPages}
            onClick={() => {
              setCurrentPage(totalPages);
              setTableDataToDisplay((prev) =>
                sortTableData({ dataToSort: tableData, sortDirection, sortDataKey, currentPage: totalPages }),
              );
            }}
          >
            Last{' '}
          </Button>
        </ButtonGroup>
      </div>
    );
  };

  const renderTable2 = () => {
    const rows = [];
    const disabledRows = [];
    const isStriped = tableType.indexOf('striped') > -1;
    const isNoHorizontal = tableType.indexOf('noHorizontalLines') > -1;

    const headerData = processHeaderRow2(tableColumnsToDisplay);
    const headerRow = headerData.headerColumns || [];
    const disabledHeaderRow = headerData.disabledHeaderColumns || [];

    tableDataToDisplay.forEach((dataRow, index) => {
      const newRow = [];
      const newDisabledRow = [];
      const { attrs = {} } = dataRow || {};

      tableColumnsToDisplay.forEach((header, colIndex) => {
        const cell = dataRow[header.dataKey];
        const { dataKey, cellFormatter, formatter, events, style, minWidth, attrs = {}, doSort } = header;
        let { width } = header;

        const cellFormatterActual = cellFormatter || formatter;
        const { onClick, onMouseEnter, onMouseLeave } = events || {};
        const styleToUse =
          style && isFunction(style) ? style({ cell, row: dataRow, rowIndex: index, colIndex }) : style;
        const attrsToUse =
          attrs && isFunction(attrs) ? attrs({ row: dataRow, index, column: header, colIndex }) : attrs;

        // if (doSort) {
        //   width = width - 15;
        // }

        if (cellFormatterActual) {
          const cellContent = cellFormatterActual(dataRow[dataKey], { ...dataRow, rowIndex: index, column: header });

          newRow.push(
            <td
              style={{
                // backgroundColor: index % 2 == 0 ? 'white' : '#e3e1e1',
                ...cellBorderStyle,
                ...styleToUse,
                width,
                minWidth,
              }}
              {...attrsToUse}
              onClick={(e) => {
                e.stopPropagation();
                if (onClick) {
                  onClick({ e, column: header, columnIndex: colIndex, row: dataRow, rowIndex: index });
                }
              }}
              onMouseEnter={(e) => {
                e.stopPropagation();
                if (onMouseEnter) {
                  onMouseEnter({ e, column: header, columnIndex: colIndex, row: dataRow, rowIndex: index });
                }
              }}
              onMouseLeave={(e) => {
                e.stopPropagation();
                if (onMouseLeave) {
                  onMouseLeave({ e, column: header, columnIndex: colIndex, row: dataRow, rowIndex: index });
                }
              }}
            >
              {cellFormatterActual(dataRow[dataKey], { ...dataRow, rowIndex: index, column: header })}
            </td>,
          );

          newDisabledRow.push(
            <td
              style={{
                ...cellBorderStyle,
                ...styleToUse,
                width,
                minWidth,
                height: 0,
                padding: 0,
                border: 'none',
                margin: 0,
                overflow: 'hidden',
                visibility: 'collapse',
              }}
              {...attrsToUse}
              // disabled={true}
            >
              {/* {cellFormatterActual(dataRow[dataKey], {
                ...dataRow,
                rowIndex: index,
                column: header,
                hiddenParent: true,
              })} */}
            </td>,
          );
        } else {
          newRow.push(
            <td
              style={{
                // backgroundColor: index % 2 == 0 ? 'white' : '#e3e1e1',
                ...cellBorderStyle,
                ...styleToUse,
                width,
                minWidth,
              }}
              onClick={(e) => {
                e.stopPropagation();
                if (onClick) {
                  onClick({ e, column: header, columnIndex: colIndex, row: dataRow, rowIndex: index });
                }
              }}
              onMouseEnter={(e) => {
                e.stopPropagation();
                if (onMouseEnter) {
                  onMouseEnter({ e, column: header, columnIndex: colIndex, row: dataRow, rowIndex: index });
                }
              }}
              onMouseLeave={(e) => {
                e.stopPropagation();
                if (onMouseLeave) {
                  onMouseLeave({ e, column: header, columnIndex: colIndex, row: dataRow, rowIndex: index });
                }
              }}
            >
              <div style={{ ...styleToUse, width, minWidth }}> {dataRow[dataKey] || ''}</div>
            </td>,
          );
          newDisabledRow.push(
            <td
              style={{
                ...cellBorderStyle,
                ...styleToUse,
                width,
                minWidth,
                height: 0,
                padding: 0,
                border: 'none',
                margin: 0,
                overflow: 'hidden',
                visibility: 'collapse',
              }}
              {...attrsToUse}
              disabled={true}
            >
              {/* <div style={{ ...styleToUse, width, minWidth }}>{dataRow[dataKey] || ''}</div> */}
            </td>,
          );
        }
      });

      rows.push(
        <tr
          {...attrs}
          style={{
            ...cellBorderStyle,
            borderBottom: '1px solid #cccaca',
            backgroundColor: index % 2 == 0 ? 'var(--rr-surface)' : 'var(--rr-surface-stripe)',
            cursor: onRowClick ? 'pointer' : 'default',
            ...rowStyle({ ...dataRow, index }),
          }}
          onClick={() => {
            if (onRowClick) {
              onRowClick({ ...dataRow, index });
            }
          }}
        >
          {newRow}
        </tr>,
      );
      disabledRows.push(
        <tr
          disabled={true}
          style={{
            // ...style.simpleRow,
            borderBottom: 'none',
            backgroundColor: isStriped ? (index % 2 == 0 ? 'var(--rr-surface)' : 'var(--rr-surface-stripe)') : 'var(--rr-surface)',
            ...rowStyle({ ...dataRow, index }),
            height: 0,
            overflow: 'hidden',
          }}
        >
          {newDisabledRow}
        </tr>,
      );
    });

    // setTableToDisplay(
    //   <>
    //     <div>
    //       <div style={{ ...style.simpleRow, overflowY: 'scroll', width: 'fit-content', minWidth: '100%' }}>
    //         <table style={{ minWidth: '100%' }}>
    //           <thead style={{ border: '2px solid #cccaca' }}>{headerRow}</thead>
    //           <tbody
    //             style={{
    //               maxHeight: tableBodyHeight,
    //               overflowY: 'auto',

    //               width: 'fit-content',
    //               minWidth: '100%',
    //             }}
    //           >
    //             {rows.map((row, i) => {
    //               return row;
    //             })}
    //           </tbody>
    //         </table>
    //       </div>
    //     </div>
    //   </>,
    // );

    // setTableToDisplay(
    //   <>
    //     <div>
    //       <div style={{ ...style.simpleRow, overflowY: 'scroll', width: 'fit-content', minWidth: '100%' }}>
    //         <table style={{ minWidth: '100%' }}>
    //           <thead style={{ border: '2px solid #cccaca' }}>{headerRow}</thead>
    //           <tbody style={{ visibility: 'collapse' }} disabled={true}>
    //             {disabledRows.map((row, i) => {
    //               return row;
    //             })}
    //           </tbody>
    //         </table>
    //       </div>
    //       <div
    //         style={{
    //           ...style.simpleRow,
    //           maxHeight: tableBodyHeight,
    //           overflowY: 'auto',
    //           alignItems: 'flex-start',
    //           borderLeft: '1px solid #cccaca',
    //           width: 'fit-content',
    //           minWidth: '100%',
    //         }}
    //       >
    //         <table style={{ minWidth: '100%' }}>
    //           <thead style={{ visibility: 'collapse' }} disabled={true}>
    //             {disabledHeaderRow}
    //           </thead>
    //           <tbody>
    //             {rows.map((row, i) => {
    //               return row;
    //             })}
    //           </tbody>
    //         </table>
    //       </div>
    //     </div>
    //   </>,
    // );

    // return;
    // return (
    //   <>
    //     <div>
    //       <div style={{ ...style.simpleRow, overflowY: 'scroll', width: 'fit-content', minWidth: '100%' }}>
    //         <table style={{ minWidth: '100%' }}>
    //           <thead style={{ border: '2px solid #cccaca' }}>{headerRow}</thead>
    //           <tbody
    //             style={{
    //               maxHeight: tableBodyHeight,
    //               overflowY: 'auto',

    //               width: 'fit-content',
    //               minWidth: '100%',
    //             }}
    //           >
    //             {rows.map((row, i) => {
    //               return row;
    //             })}
    //           </tbody>
    //         </table>
    //       </div>
    //     </div>
    //   </>
    // );
    return (
      <>
        {/* <div style={{ ...style.simpleRow }}>
          <Input
            type="switch"
            onChange={() => {
              setShowHidden(!showHidden);
            }}
            checked={showHidden}
          />{' '}
          <Label>Show Hidden</Label>
        </div> */}
        <div
          style={{
            ...style.simpleRow,
            // overflowX: 'scroll',
            width: '100%',
            justifyContent: 'flex-start',
            alignItems: 'flex-start',
          }}
        >
          <div
            style={{
              ...style.simpleColumn,
              width: '100%',
              justifyContent: 'flex-start',
              alignItems: 'flex-start',
            }}
          >
            <div
              style={{
                ...style.simpleRow,
                height: tableBodyHeight,
                overflow: 'auto',
                width: '100%',
                border: '3px solid #cccaca',
                justifyContent: 'flex-start',
                alignItems: 'flex-start',
              }}
            >
              <table style={{ minWidth: '100%', borderCollapse: 'collapse' }}>
                <thead
                  style={{
                    // border: '5px solid #cccaca',
                    top: -2,
                    boxShadow: '-20px 0 0 0 gray',
                    // marginLeft: -10,
                    position: 'sticky',
                    zIndex: 30,
                    backgroundColor: 'var(--rr-surface)',
                    margin: 0,
                    padding: 0,
                  }}
                >
                  {headerRow}
                </thead>
                <tbody>
                  {rows.map((row, i) => {
                    return row;
                  })}
                  {/* {disabledRows[0] ? disabledRows[0] : null} */}
                  {/* {disabledRows.map((row, i) => {
                    return row;
                  })} */}
                </tbody>
              </table>
            </div>
            {/* <div
              ref={tableRef}
              onScroll={handleScroll}
              style={{
                ...style.simpleRow,
                maxHeight: tableBodyHeight,
                minHeight: tableBodyHeight,
                overflowY: 'auto',
                alignItems: 'flex-start',
                borderLeft: '1px solid #cccaca',
                width: 'fit-content',
                minWidth: '100%',
              }}
            >
              <table style={{ minWidth: '100%' }}>
                <thead style={{ visibility: showHidden ? 'visible' : 'collapse', border: '2px solid #cccaca' }}>
                  {disabledHeaderRow}
                </thead>
                <tbody>
                  {rows.map((row, i) => {
                    return row;
                  })}
                </tbody>
              </table>
            </div> */}
          </div>
        </div>
        {isPaginated ? renderPagination({ currentPage, pageNumbers }) : null}
      </>
    );
    return (
      <div
        className="rez-rate-table"
        style={{ ...style.simpleRow, justifyContent: 'flex-start', alignItems: 'flex-start' }}
      >
        <div style={{ ...style.simpleColumn, width: 'auto', justifyContent: 'flex-start', alignItems: 'flex-start' }}>
          {headerRow}
          <div
            style={{
              ...style.simpleRow,
              overflowY: 'auto',
              width: '100%',
              height: tableBodyHeight,
              alignItems: 'flex-start',
            }}
          >
            <div style={style.simpleColumn}>
              {rows.map((row, i) => {
                return row;
              })}
              {!rows || rows.length <= 0 ? (
                <div
                  style={{
                    ...style.simpleRow,
                    padding: 5,
                    width: '100%',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  {noDataMessage || ''}
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    );
  };

  // return tableToDisplay;
  return renderTable2();
};

export default RezRateTable;
